<template>
  <div  style="overflow:auto;width:fit-content;margin:auto;">
        <v-layout class="mx-1" justify-center align-center v-for="row in config.rows" :key="row">
            <div class="seat-container" v-for="col in config.cols" :key="col" >
                <div v-tooltip="{
                    content: _seatTooltipContent(_seatId(row,col)),
                    placement: 'top-center',
                    classes: ['org-theme'],
                    targetClasses: ['it-has-a-tooltip'],
                    offset:0,
                    delay:{ show: 500, hide: 100 },
                    }"
                    v-if="_isSeatAccessible(_seatId(row,col))"
                    :class="_classifier(_seatId(row,col))" class="text-xs-center" @click.stop="onSeatSelected(_seatId(row,col))">
                    <div>{{_seatLabel(_seatId(row,col))}}</div>
                    <SeatSVG :width="'30px'" :classifier="_classifier(_seatId(row,col))"></SeatSVG>
                </div>
                <!-- Blank space / Aisle-->
                <div v-else style="margin:14px"></div>
            </div>
        </v-layout>
    </div>
</template>
<script>
import SeatSVG from "@/components/SeatSVG"
import {seatMethods,seatCategoryMethods} from "@/mixins/seats"
import { currencySymbol } from "@/mixins/currencySymbol";
import { mapState } from "vuex";

export default {
    name:"SeatsChart",
    props:{
        config:{
            type:Object,
            default:{}
        },
        seats:{
            type:Object,
            default:{}
        },
        reservedSeats:{
            type:Object,
            default:{}
        },
        seatsStatus:{
            type:Object,
            default:{}
        },
        selectedSeats:{
            type:Array,
            default:[]
        },
        seatPricing:{
            type:Object,
            default:{}
        },
    },
    components:{
        SeatSVG
    },
    mixins:[seatMethods,seatCategoryMethods,currencySymbol],
    computed:{
        ...mapState({
            company: (state) => state.company.company,
        }),
    },
    methods:{
        /** Returns seat status @return Number|String 10|20|30|... */
        _seatStatus(seatId){
            if(!this.seatsStatus.hasOwnProperty(seatId)){
                return;
            }
            return this.seatsStatus[seatId]['status'];
        },
        /** Returns suitable class according to status/category @return String */
        _classifier(seatId){
            if(!this._isSeatExists(seatId)){
               return;
            }

            if(this._isSeatSelected(seatId)){
                return "cls-seat-selected";
            }

            if(!this.seatsStatus){
                let category = this._categoryClassifier(this._seatCategory(seatId));
                return category.colorClass;
            }

            //FIXME: preapare for both types
            switch(this._seatStatus(seatId)) {
                case this.DEFINES.SEATS_STATUS.AVAILABLE:
                    if(this._isSeatSelected(seatId)){
                        return "cls-seat-selected";
                    }
                    let category = this._categoryClassifier(this._seatCategory(seatId));
                    return category.colorClass;
                case this.DEFINES.SEATS_STATUS.LOCKED:
                    return 'cls-seat-reserved';
                case this.DEFINES.SEATS_STATUS.BOOKED:
                    return 'cls-seat-booked';
                default:
                     return 'cls-seat-available';
            }
        },
         /** Prepare & returns HTML string @return String */
        _seatTooltipContent(seatId){
            let seatLabel = this._seatLabel(seatId);
            let seatCategory = this._categoryClassifier(this._seatCategory(seatId));
            let seatPrice = this.getCurrencySymbol(this.company.currency)+this._seatPrice(seatId);

            return this.$t("screener.seats.label.title")+" : <b>"+seatLabel+"</b><br/>"+this.$t("screener.seats.category.title")+" : <b>"+seatCategory.label+"</b><br/>"+this.$t("screener.seats.price.title")+" : <b>"+seatPrice+"</b>";
        },
        onSeatSelected(seatId){
            this.$emit("onSeatSelected",seatId);
        }
    }
}
</script>

<style scoped>
.seat-container{
    padding:2.5px;
    min-width: 2%;
    font-size: smaller;
}
</style>

